import { JobMatchQueryFilter } from "../../../../../models/jobMatchQueryFilter";
export class MatchedCandidatesContainer {
    constructor(userId, companyId, jobId, associateCandidatesDefaultFilter, jobDetails, pageSize, jobMatchService, jobService, candidateService, alertsAndNotificationsService) {
        this.userId = userId;
        this.companyId = companyId;
        this.jobId = jobId;
        this.associateCandidatesDefaultFilter = associateCandidatesDefaultFilter;
        this.jobDetails = jobDetails;
        this.pageSize = pageSize;
        this.jobMatchService = jobMatchService;
        this.jobService = jobService;
        this.candidateService = candidateService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$onInit();
    }
    $onInit() {
        this.candidates = [];
        this.selectedCandidates = [];
        this.busy = false;
        this.candidatesExistFlag = true;
        this.defaultPageSize = this.pageSize;
        this.searchObject = new SearchObject(this.jobId, this.companyId, this.pageSize, this.associateCandidatesDefaultFilter, this.jobDetails.fourDotFiveIntelligenceScore);
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
        this.searchByTextFlag = false;
        this.totalCandidateCount = null;
        this.selectAllDoneFlag = false;
        this.topMatches = 0;
        this.isFilterOn = false;
    }
    getNext() {
        if (this.busy)
            return;
        this.busy = true;
        if (this.searchObject.page == '') {
            this.searchObject.page = 1;
        }
        let tempSearchObject = angular.copy(this.searchObject);
        if (this.searchByTextFlag) {
            delete tempSearchObject.minimumScore;
            delete tempSearchObject.maximumScore;
        }
        else {
            delete tempSearchObject.searchText;
        }
        if (tempSearchObject.numberOfDays == 0) {
            delete tempSearchObject.numberOfDays;
        }
        this._setIsFilterOn(tempSearchObject);
        tempSearchObject.loggedInUserId = this.userId;
        this.currentPromise = this.jobService.findMatchingCandidatesForJob(tempSearchObject, (data) => {
            if (this.searchObject.page == 1) {
                // if it is first page, reset the candidates/data array.
                this.candidates = [];
            }
            if (angular.isDefined(data) && data != 'user cancellation') {
                this.totalCandidateCount = data.count;
                if (data.candidateMinimumInfoDtos.length > 0) {
                    angular.forEach(data.candidateMinimumInfoDtos, (val, key) => {
                        let basicCandidateInfo = this._getBasicCandidateInfo(val);
                        let currentIndex = this.candidates.length;
                        if (((currentIndex + 1) % 3) == 1) {
                            basicCandidateInfo.jobMatchesPopoverPosition = 'bottom-left';
                        }
                        else if (((currentIndex + 1) % 3) == 0) {
                            basicCandidateInfo.jobMatchesPopoverPosition = 'bottom-right';
                        }
                        this.getCandidateJobMatches(basicCandidateInfo.id, this.userId, this.companyId, (data) => {
                            basicCandidateInfo.candidateJobMatches = data;
                            basicCandidateInfo.context = 'associateCandidates';
                        });
                        let index = _.findIndex(this.selectedCandidates, {
                            id: basicCandidateInfo.id
                        });
                        if (index >= 0) {
                            basicCandidateInfo.selectedFlag = true;
                        }
                        else {
                            basicCandidateInfo.selectedFlag = false;
                        }
                        this.candidates.push(basicCandidateInfo);
                    });
                    // if the length of the returned values is less than page size, it means there are not enough values.
                    // hence we can disable the infinite scroll
                    if (data.candidateMinimumInfoDtos.length < this.searchObject.size || tempSearchObject.size != this.defaultPageSize) {
                        this.disableInfiniteScroll = true;
                    }
                    else {
                        this.searchObject.page++;
                    }
                }
                else {
                    // if the length of the returned values is 0, it means there are no more values.
                    // hence we can disable the infinite scroll
                    this.disableInfiniteScroll = true;
                }
                // set the candidates exist flag based on existence of candidates.
                if (this.candidates.length > 0) {
                    this.candidatesExistFlag = true;
                }
                else {
                    this.candidatesExistFlag = false;
                }
            }
            //set this.busy to false
            this.busy = false;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            // stop further infinite-scroll attempts when server returns error
            this.disableInfiniteScroll = true;
            // indicate no candidates available after error to avoid repeated calls
            this.candidatesExistFlag = false;
            this.currentPromise = null;
            this.busy = false;
        });
    }
    _setIsFilterOn(tempSearchObject) {
        let filter = tempSearchObject;
        if ((!filter.minimumScore && !filter.maximumScore && (filter.searchText.length > 0))
            || (!filter.searchText && (filter.minimumScore && filter.minimumScore > this.jobDetails.fourDotFiveIntelligenceScore))
            || (!filter.searchText && (filter.maximumScore && filter.maximumScore < 100))
            || (filter.numberOfDays && (filter.numberOfDays > 0))
            || filter.workLocationIds.length > 0
            || filter.sponsorships.length > 0
            || filter.jobTypes.length > 0
            || filter.jobSubTypes.length > 0
            || filter.sponsorships.length > 0
            || filter.salary > 0
            || filter.rate > 0
            || (filter.column != "" && filter.sortDirection != "")) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    }
    _getBasicCandidateInfo(candidate) {
        let basicCandidateInfo = {};
        basicCandidateInfo.name = candidate.contact.firstname + ' ' + candidate.contact.lastname;
        basicCandidateInfo.id = candidate.id;
        basicCandidateInfo.email = candidate.contact.email;
        basicCandidateInfo.mobilePhone = candidate.contact.mobilephone;
        basicCandidateInfo.workPhone = candidate.contact.workphone;
        basicCandidateInfo.matchScore = candidate.matchScore;
        basicCandidateInfo.candidateStatus = candidate.candidateStatus;
        if (!_.isNull(candidate.lastModifiedDate)) {
            basicCandidateInfo.lastModifiedDate = new Date(candidate.lastModifiedDate);
        }
        basicCandidateInfo.candidateJobMatches = [];
        basicCandidateInfo.jobMatchesPopoverPosition = 'bottom';
        if (_.isNull(basicCandidateInfo.matchScore)) {
            basicCandidateInfo.matchScore = 'N/A';
        }
        else {
            basicCandidateInfo.intelligenceScorePassFlag = false;
            if (basicCandidateInfo.matchScore >= this.jobDetails.fourDotFiveIntelligenceScore) {
                basicCandidateInfo.intelligenceScorePassFlag = true;
            }
            // round the match score to the lower integer value.
            basicCandidateInfo.matchScore = Math.floor(parseFloat(basicCandidateInfo.matchScore));
        }
        basicCandidateInfo.allowManualMatch = candidate.allowManualMatch;
        basicCandidateInfo.showOverride = candidate.showOverride;
        basicCandidateInfo.allowOverride = candidate.allowOverride;
        basicCandidateInfo.overrideFor = candidate.overrideFor;
        basicCandidateInfo.reasonForNoManualMatch = candidate.reasonForNoManualMatch;
        basicCandidateInfo.releaseDate = candidate.releaseDate;
        basicCandidateInfo.suspendedMonths = candidate.suspendedMonths;
        basicCandidateInfo.releasedCandidateDetail = candidate.releasedCandidateDetail;
        basicCandidateInfo.jobLeftDetail = candidate.jobLeftDetail;
        basicCandidateInfo.workLocations = candidate.workLocations;
        basicCandidateInfo.workLocationsMatchStatus = this.jobMatchService.getJobAndCandidateWorkLocationsMatchStatus(this.jobDetails.workLocations, candidate.workLocations);
        basicCandidateInfo.candidateAdditionalDetailsCard = candidate.candidateAdditionalDetailsCard;
        basicCandidateInfo.resumeExist = candidate.resumeExist;
        basicCandidateInfo.matchingMandatoryCriteria = candidate.matchingMandatoryCriteria;
        return basicCandidateInfo;
    }
    getCandidateJobMatches(candidateId, userId, companyId, successCallback) {
        let candidateJobMatches = [];
        let jobMatchesObject = new JobMatchQueryFilter();
        jobMatchesObject.candidateId = candidateId;
        jobMatchesObject.userId = userId;
        jobMatchesObject.companyId = companyId;
        jobMatchesObject.top5Flag = false;
        jobMatchesObject.candidateType = "OWN_CANDIDATES";
        jobMatchesObject.searchText = '';
        jobMatchesObject.vendorIds = [];
        this.candidateService.getCandidateJobMatches(jobMatchesObject, 1, 250, (data) => {
            angular.forEach(data, (val, key) => {
                val.jobMatchDate = new Date(val.jobMatchDate);
                candidateJobMatches.push(val);
            });
            if (successCallback) {
                successCallback(candidateJobMatches);
            }
        }, (error) => {
            console.log('candidate job matches get error - ', error);
            // do nothing.
        });
    }
}
class SearchObject {
    constructor(jobId, companyId, size, associateCandidatesDefaultFilter, minimumScore) {
        this.requisitionId = jobId;
        this.companyId = companyId;
        this.size = size;
        this.searchText = "";
        this.page = "";
        this.minimumScore = minimumScore;
        this.maximumScore = 100;
        this.numberOfDays = 0;
        this.withoutJobMatchScore = false;
        this.includeCandidatesMatchingMandatoryCriteria = false;
        this.requestSource = associateCandidatesDefaultFilter.requestSource;
        this.workLocationIds = associateCandidatesDefaultFilter.workLocationIds;
        this.sponsorships = associateCandidatesDefaultFilter.sponsorships;
        this.jobTypes = associateCandidatesDefaultFilter.jobTypes;
        this.jobSubTypes = associateCandidatesDefaultFilter.jobSubTypes;
        this.salary = associateCandidatesDefaultFilter.salary;
        this.salaryDuration = associateCandidatesDefaultFilter.salaryDuration;
        this.rate = associateCandidatesDefaultFilter.rate;
        this.rateDuration = associateCandidatesDefaultFilter.rateDuration;
        this.salaryCurrency = associateCandidatesDefaultFilter.salaryCurrency;
        this.rateCurrency = associateCandidatesDefaultFilter.rateCurrency;
        this.column = associateCandidatesDefaultFilter.column;
        this.sortDirection = associateCandidatesDefaultFilter.sortDirection;
        this.includeCandidatesWithNoAdditionalDetails = associateCandidatesDefaultFilter.includeCandidatesWithNoAdditionalDetails;
        //this.column = 'matchScore';
        //this.sortDirection = 'DSC';
    }
}
//# sourceMappingURL=matched-candidates-infinite-scroll-container.js.map